import { 
    GET_BULK_ORDER_COST_CENTER, 
    GET_COST_CENTERS, 
    GET_COST_CENTER_BY_GROUP, 
    GET_COST_CENTER_BY_REGION, 
    GET_COST_CENTER_GROUPS, 
    SET_BULK_ORDER_COST_CENTER, 
    SET_COSTCENTER_WITH_DIVISIONID, 
    SET_COST_CENTERS, 
    SET_COST_CENTER_BY_GROUP, 
    SET_COST_CENTER_BY_REGION, 
    SET_COST_CENTER_GROUPS,
    GET_COST_CENTERS_BY_BRANCH,
    SET_COST_CENTERS_BY_BRANCH,
    GET_COST_CENTER_BY_SEARCH_STRING,
    SET_COST_CENTER_BY_SEARCH_STRING 
} from "./CostCentersType";

const getCostCenters = (divisionId: any) => ({
    type: GET_COST_CENTERS,
    divisionId: divisionId
});

const setCostCenters = (costCentersDropDownList: any) => ({
    type: SET_COST_CENTERS,
    costCentersDropDownList: costCentersDropDownList
});

const setCostCentersWithDivisionId = (costCenterWithDivisionId: any) => ({
    type: SET_COSTCENTER_WITH_DIVISIONID,
    costCenterWithDivisionId: costCenterWithDivisionId
});

const getCostCenterGroups = (regionId: any) => ({
    type: GET_COST_CENTER_GROUPS,
    regionId: regionId
});

const setCostCenterGroups = (groupList: any) => ({
    type: SET_COST_CENTER_GROUPS,
    groupList: groupList
});

const getCostCenterByRegion = (regionId: any) => ({
    type: GET_COST_CENTER_BY_REGION,
    regionId: regionId
});

const setCostCenterByRegion = (costCenterList: any) => ({
    type: SET_COST_CENTER_BY_REGION,
    costCenterList: costCenterList
});

const getCostCenterByGroup = (groupId: any) => ({
    type: GET_COST_CENTER_BY_GROUP,
    groupId: groupId
});

const setCostCenterByGroup = (costCenterList: any) => ({
    type: SET_COST_CENTER_BY_GROUP,
    costCenterList: costCenterList
});

const getBulkOrderCostCenter = () => ({
    type: GET_BULK_ORDER_COST_CENTER
});

const setBulkOrderCostCenter = (costCenterList: any) => ({
    type: SET_BULK_ORDER_COST_CENTER,
    costCenterList
});

const getCostCenterByBranch = (branchId: any) => ({
    type: GET_COST_CENTERS_BY_BRANCH,
    branchId
});

const setCostCenterByBranch = (response: any) => ({
    type: SET_COST_CENTERS_BY_BRANCH,
    response
});

const getCostCenterBySearchString = (searchText: any, isHierarchy : any = false) => ({
    type: GET_COST_CENTER_BY_SEARCH_STRING,
    searchText,
    isHierarchy
});

const setCostCenterBySearchString = (response: any) => ({
    type: SET_COST_CENTER_BY_SEARCH_STRING,
    response
});

export {
    getCostCenters,
    setCostCenters,
    getCostCenterGroups,
    setCostCenterGroups,
    getCostCenterByRegion,
    setCostCenterByRegion,
    getCostCenterByGroup,
    setCostCenterByGroup,
    setCostCentersWithDivisionId,
    getBulkOrderCostCenter,
    setBulkOrderCostCenter,
    getCostCenterByBranch,
    setCostCenterByBranch,
    getCostCenterBySearchString,
    setCostCenterBySearchString
}
